import React from "react";
import { DefaultNavBar, NavBar } from "@me8eon/navbar";
import { makeContextFor, makeContextForState, makeUseStateChild } from "@me8eon/context";
import { NameAnd } from "@me8eon/record_utils";
import { useWindowUrlData } from "@me8eon/routing";


export type DevModeComponent = () => React.ReactElement;
export type DevModeComponents = NameAnd<DevModeComponent>

export type SearchDevModeComponents = {
    DevModeNavBar: NavBar
    components: DevModeComponents
}


export const simpleDevModeComponents = (devModeComponents: DevModeComponents): SearchDevModeComponents => ({
    DevModeNavBar: DefaultNavBar("devmode", Object.keys(devModeComponents)),
    components: devModeComponents,
});
export const { Provider: DevModeComponentsProvider, use: useDevModeComponents } = makeContextFor<SearchDevModeComponents, "components">("components");

export type DevModeState = {
    selected: string
}
export const { Provider: DevModeStateForSearchProvider, use: useDevModeState } = makeContextForState<DevModeState, "devModeState">("devModeState");
export const useDevModeSelected = makeUseStateChild<DevModeState, string>(useDevModeState, id => id.focusOn("selected"));


export function DevMode() {
    const { DevModeNavBar, components } = useDevModeComponents();
    const selectedOps = useDevModeSelected();
    const [dm]=selectedOps
    const [urlData] = useWindowUrlData();

    const allowedbyUserType = true;
    const devModeReqestedAndAllowed = allowedbyUserType && (urlData.url.searchParams.get("devMode") || dm)
    if (!devModeReqestedAndAllowed) return <></>;
    const [selected] = selectedOps;
    const Component = components[selected] || (() => <></>);
    return <div className="dev-mode">
        <hr />
        <DevModeNavBar selectedOps={selectedOps} />
        <Component />
    </div>;
}